import { Modal } from "react-bootstrap"
import { locationDev } from "../../services/Servicos"

export default function ModalFotoReport({ show, setShow, imgSrc }) {
    const handlerSimpleClose = () => setShow(last => ({ ...last, flag: false }))

    return (
        <>
            <Modal
                show={show}
                onHide={handlerSimpleClose}
                backdrop='static'
                keyboard={false}
                centered
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Foto Enviada</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{ textAlign: "center" }}>
                        <img  src={locationDev + '/files/users/'+ imgSrc} alt='Imagem Perfil' width={'80%'} height={'100%'}  />
                    </p>
                </Modal.Body>
            </Modal>
        </>
    )
}
